import React, { useEffect, useContext } from "react";
import { useHistory } from "react-router";
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import { AuthContext } from "../../utils/userProvider";

import useChangePassword from "../../mutation/changePassword/changePassword.js";

const schema = yup.object().shape({
  password: yup.string().required("password is required"),
  confirmPassword: yup.string().required("Re-enter your password"),
});

const NewUser = (props) => {
  const history = useHistory();

  const [createResponse, setData] = useChangePassword();

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const { authState, setAuthState } = useContext(AuthContext);

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  const onSubmit = (values) => {
    if (values.password != values.confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Passwords do not match",
      });
    } else if (values.password.length < 5) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Password length should be greater than 5 characters",
      });
    } else {
      setData(values);
    }
  };

  const goBack = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  useEffect(() => {
    try {
      if (createResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Password Changed",
        });
        let newAuthState = authState;
        newAuthState.firstLogin = false;
        setAuthState(newAuthState);
        history.push("/dashboard");
      } else if (createResponse.error) {
        let data = createResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;
          Swal.fire({
            icon: "error",
            title: "Error",
            text: message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: createResponse.error.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [createResponse]);

  return (
    <Grid container component="main" sx={{ minHeight: "100vh" }}>
      <Grid
        item
        xs={false}
        sm={4}
        md={5}
        sx={{
          backgroundImage: "url(img/login.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(160deg, rgba(0,186,178,0.35) 0%, rgba(13,45,44,0.45) 100%)",
          },
        }}
      />
      <Grid
        item
        xs={12}
        sm={8}
        md={7}
        component={Paper}
        elevation={0}
        square
        sx={{
          display: "flex",
          alignItems: "center",
          bgcolor: "#fbfcfc",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 440,
            mx: "auto",
            px: { xs: 3, sm: 4 },
            py: { xs: 6, sm: 8 },
          }}
        >
          <IconButton
            onClick={goBack}
            aria-label="back"
            sx={{ color: "primary.main", p: 0, mb: 2 }}
          >
            <ArrowBackIcon />
          </IconButton>

          <Box
            component="img"
            src="img/logo.png"
            alt="YSuites"
            sx={{ height: 48, mb: 2.5, display: "block" }}
          />

          <Typography
            component="h1"
            variant="h4"
            sx={{
              color: "primary.main",
              fontWeight: 800,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              mb: 0.5,
            }}
          >
            Middleware
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            First-time users are required to change their passwords.
          </Typography>

          <Divider sx={{ mb: 3 }} />

          <Typography component="h2" variant="h5" sx={{ mb: 2 }}>
            First Login
          </Typography>

          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <TextField
              name="password"
              margin="normal"
              type="password"
              fullWidth
              label="Password*"
              inputRef={register}
              error={errors.name != null}
              helperText={errors.name != null ? errors.name.message : null}
              disabled={createResponse.loading}
            />
            <TextField
              name="confirmPassword"
              margin="normal"
              type="password"
              fullWidth
              label="Confirm Password*"
              inputRef={register}
              error={errors.name != null}
              helperText={errors.name != null ? errors.name.message : null}
              disabled={createResponse.loading}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ mt: 3, mb: 2, py: 1.25 }}
              disabled={createResponse.loading}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default NewUser;
